import { AccordionFoldButton } from '@redneckz/wildless-cms-uni-blocks/lib/components/RollupItem/AccordionFoldButton';
import { getFoldableStyles } from '@redneckz/wildless-cms-uni-blocks/lib/components/RollupItem/getFoldableStyles';
import { useMobileMode } from '@redneckz/wildless-cms-uni-blocks/lib/hooks/useMobileMode';
import { Foldable } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Foldable/Foldable';
import { type FoldablePartProps } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Foldable/FoldablePartProps';
import { FoldableSection } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Foldable/FoldableSection';
import { style } from '@redneckz/wildless-cms-uni-blocks/lib/utils/style';
import React from 'react';
import { JournalistInfo } from './JournalistInfo';
import { NewsFilter } from './NewsFilter';

interface NewsRightBlockProps {
  className?: string;
  hideCategories?: boolean;
  categories?: Queries.Maybe<Queries.PortalResourcesJsonItems>[];
  isFoldable?: boolean;
}

export const NewsRightBlock = ({
  className = '',
  hideCategories,
  categories,
  isFoldable = false,
}: NewsRightBlockProps) => {
  const isMobile = useMobileMode();

  return (
    <div className={className}>
      {isFoldable ? (
        <Foldable
          className={style(hideCategories && 'hidden')}
          renderFoldableSection={({ isUnfolded }) => (
            <FoldableSection className={getFoldableStyles(isMobile)} isUnfolded={isUnfolded}>
              <NewsFilter categories={categories} hideCategories={hideCategories} />
            </FoldableSection>
          )}
          renderFoldButton={({ isUnfolded, onToggle }) =>
            renderFoldButton({
              isUnfolded,
              onToggle,
            })
          }
        />
      ) : (
        <NewsFilter categories={categories} hideCategories={hideCategories} />
      )}
      <JournalistInfo className="hidden sm:block p-3xl bg-white grow" />
    </div>
  );
};

const renderFoldButton = ({ isUnfolded, onToggle }: FoldablePartProps) => (
  <div className="p-3xl !py-0 bg-white text-primary-main">
    <div className="pb-xs w-fit">
      <AccordionFoldButton
        label={isUnfolded ? 'Скрыть' : 'Фильтры'}
        icon={isUnfolded ? 'ArrowUpIcon' : 'ArrowDownIcon'}
        onToggle={onToggle}
      />
    </div>
  </div>
);
